/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarket,
    BrandAndMarketFromJSON,
    BrandAndMarketFromJSONTyped,
    BrandAndMarketToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarkupV2ListConfiguration
 */
export interface MarkupV2ListConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarket>}
     * @memberof MarkupV2ListConfiguration
     */
    allowedBrandsAndMarkets?: Array<BrandAndMarket> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof MarkupV2ListConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof MarkupV2ListConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MarkupV2ListConfiguration
     */
    relevance?: Array<number> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof MarkupV2ListConfiguration
     */
    readonly providers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof MarkupV2ListConfiguration
     */
    readonly fareTypes?: Array<CodeAndLabel> | null;
}

export function MarkupV2ListConfigurationFromJSON(json: any): MarkupV2ListConfiguration {
    return MarkupV2ListConfigurationFromJSONTyped(json, false);
}

export function MarkupV2ListConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupV2ListConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedBrandsAndMarkets': !exists(json, 'allowedBrandsAndMarkets') ? undefined : (json['allowedBrandsAndMarkets'] === null ? null : (json['allowedBrandsAndMarkets'] as Array<any>).map(BrandAndMarketFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
    };
}

export function MarkupV2ListConfigurationToJSON(value?: MarkupV2ListConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedBrandsAndMarkets': value.allowedBrandsAndMarkets === undefined ? undefined : (value.allowedBrandsAndMarkets === null ? null : (value.allowedBrandsAndMarkets as Array<any>).map(BrandAndMarketToJSON)),
        'relevance': value.relevance,
    };
}


